import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getSnackbarMessage } from 'views/Dashboard/helpers';
import { resetScheduleMessage } from 'redux/actions';

export const useScheduleMessageSnackbarUpdate = ({ setSnackbarMessage, setOpenSnackBar }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { scheduleMessageUpdated, sendNow, scheduleMessage } = useSelector(
    (state) => state.scheduleMessage,
  );

  useEffect(() => {
    if (scheduleMessageUpdated) {
      const msg = getSnackbarMessage({ t, scheduleMessage, sendNow });

      setSnackbarMessage(msg);
      setOpenSnackBar(true);
      dispatch(resetScheduleMessage());
    }
  }, [
    t,
    scheduleMessageUpdated,
    sendNow,
    setSnackbarMessage,
    setOpenSnackBar,
    scheduleMessage,
    dispatch,
  ]);

  return scheduleMessageUpdated;
};
